import React, { useState, useEffect } from 'react';
import { Container, Nav, Button } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  FaUser,
  FaSignOutAlt,
  FaHome,
  FaUsers,
  FaBuilding,
  FaProjectDiagram,
  FaUtensils,
  FaBarcode,
  FaChartBar,
  FaFileAlt,
  FaCog,
  FaCogs,
  FaChartLine,
  FaUserFriends,
  FaBars,
  FaChevronLeft,
  FaChevronDown,
  FaChevronUp,
  FaUserShield,
  FaUserCog,
  FaUserTie,
  FaHotel,
  FaBed,
  FaMapMarkerAlt,
  FaClipboardList,
  FaFileExcel,
  FaMoneyBillWave,
  FaLayerGroup,
  FaTruck,
  FaCalendarAlt,
  FaRuler,
  FaBox,
  FaToggleOn,
  FaHistory,
  FaList,
  FaTrashAlt,
  FaSearch,
  FaAddressCard,
  FaExchangeAlt,
  FaCopy,
  FaLink,
  FaPrint,
  FaFileInvoice,
  FaTags,
  FaExclamationTriangle,
  FaCoins,
  FaFilePdf,
  FaLaptop,
  FaCloudDownloadAlt,
} from 'react-icons/fa';
import { MdLogin, MdDelete } from 'react-icons/md';
import { useAuth } from '../services/hooks/useAuth';
import menusApi from '../services/api/menusApi';
import {
  filterMenuForCorporativo,
  isCorporativoProject,
} from '../utils/projectRouteAccess';

// Mapa de iconos string a componentes React
const iconMap = {
  FaUser, FaSignOutAlt, FaHome, FaUsers, FaBuilding, FaProjectDiagram,
  FaUtensils, FaBarcode, FaChartBar, FaFileAlt, FaCog, FaCogs,
  FaChartLine, FaUserFriends, FaBars, FaChevronLeft, FaChevronDown,
  FaChevronUp, FaUserShield, FaUserCog, FaUserTie, FaHotel, FaBed,
  FaMapMarkerAlt, FaClipboardList, FaFileExcel, FaMoneyBillWave,
  FaCalendarAlt, FaRuler, FaBox, FaToggleOn, FaHistory, FaList, FaTrashAlt,
  FaSearch, FaAddressCard, FaExchangeAlt, FaPrint, FaFileInvoice,
  FaTags, FaExclamationTriangle,FaCoins, FaLaptop, FaCloudDownloadAlt,
  MdLogin, MdDelete,
};

const getIconComponent = (iconName) => {
  if (!iconName) return <FaCog />;
  const IconComponent = iconMap[iconName];
  return IconComponent ? <IconComponent /> : <FaCog />;
};

// Convertir estructura del backend (hijos) a estructura del frontend (items)
const convertMenuStructure = (menuItems) => {
  if (!menuItems || !Array.isArray(menuItems)) return [];
  
  return menuItems.map(item => {
    // Corregir ruta de depósitos: /depositos -> /corporativo/depositos
    let correctedPath = item.path;
    if (item.path === '/depositos' && item.label?.toLowerCase().includes('depósito')) {
      correctedPath = '/corporativo/depositos';
      console.log('🔧 [convertMenuStructure] Corrigiendo ruta de depósitos:', item.path, '->', correctedPath);
    }
    
    const converted = {
      id: item.id?.toString() || item.label?.toLowerCase().replace(/\s+/g, '-'),
      label: item.label,
      icon: getIconComponent(item.icon),
      path: correctedPath,
    };
    
    // Si tiene hijos, convertirlos recursivamente
    if (item.hijos && item.hijos.length > 0) {
      converted.items = convertMenuStructure(item.hijos);
    }
    
    return converted;
  });
};

// Menú hardcodeado como fallback (fuera del componente para evitar recrearlo)
const DEFAULT_MENU_CATEGORIES = [
  {
    id: 'mantenimientos',
    label: 'Mantenimientos',
    icon: <FaCog />,
    items: [
      {
        id: 'alimentacion',
        label: 'Alimentación',
        icon: <FaUtensils />,
        items: [
          { path: '/mantenimientos/alimentacion/comedores', label: 'Comedores', icon: <FaUtensils /> },
          { path: '/mantenimientos/alimentacion/lectoras', label: 'Lectoras', icon: <FaBarcode /> },
          { path: '/mantenimientos/alimentacion/comedor-lectores-offline', label: 'Comedores Lectores Offline', icon: <FaLaptop /> },
          { path: '/mantenimientos/alimentacion/comensales', label: 'Comensales', icon: <FaUserFriends /> },
          { path: '/mantenimientos/alimentacion/tipo-servicios-alimentacion', label: 'Tipo Servicios Alimentación', icon: <FaCog /> },
          { path: '/mantenimientos/alimentacion/tipo-servicios-comedor', label: 'Tipo Servicios Comedor', icon: <FaCog /> },
          { path: '/mantenimientos/alimentacion/tipos-origen-trabajadores', label: 'Tipos de Origen de Trabajadores', icon: <FaUserTie /> },
          { path: '/mantenimientos/alimentacion/tipos-servicios-alimentacion-origen', label: 'Servicios Alimentación - Origen', icon: <FaCog /> },
          { path: '/mantenimientos/alimentacion/homologacion-excel', label: 'Homologación Excel', icon: <FaFileExcel /> },
        ]
      },
      {
        id: 'hoteleria',
        label: 'Hotelería',
        icon: <FaHotel />,
        items: [
          { path: '/mantenimientos/hoteleria/zonas', label: 'Zonas', icon: <FaMapMarkerAlt /> },
          { path: '/mantenimientos/hoteleria/modulos', label: 'Módulos', icon: <FaBuilding /> },
          { path: '/mantenimientos/hoteleria/tipos-valorizacion', label: 'Tarifas Valorización', icon: <FaMoneyBillWave /> },
          { path: '/mantenimientos/hoteleria/parametria-modulos', label: 'Parametría Módulos', icon: <FaCog /> },
          { path: '/mantenimientos/hoteleria/habitaciones', label: 'Habitaciones', icon: <FaHotel /> },
          { path: '/mantenimientos/hoteleria/camas', label: 'Camas', icon: <FaBed /> },
          { path: '/mantenimientos/hoteleria/trabajadores', label: 'Trabajadores', icon: <FaUserTie /> },
          { path: '/mantenimientos/hoteleria/parametria-carga-masiva-trabajadores', label: 'Parametria Carga Masiva Trabajadores', icon: <FaFileExcel /> },
          { path: '/mantenimientos/hoteleria/estructura-impresion-ticket', label: 'Estructura Impresión Ticket', icon: <FaFileAlt /> },
          { path: '/mantenimientos/hoteleria/estaciones-impresion', label: 'Estaciones de Impresión Ticket', icon: <FaPrint /> },
        ]
      },
      {
        id: 'planificacion',
        label: 'Planificación de Insumos',
        icon: <FaCalendarAlt />,
        items: [
          { path: '/mantenimientos/planificacion/familias-insumos', label: 'Familias de Insumos', icon: <FaFileExcel /> },
          { path: '/mantenimientos/planificacion/subfamilias-insumos', label: 'Subfamilias de Insumos', icon: <FaFileExcel /> },
          { path: '/mantenimientos/planificacion/unidades-medida', label: 'Unidades de Medida', icon: <FaRuler /> },
          { path: '/mantenimientos/planificacion/insumos', label: 'Insumos', icon: <FaBox /> },
          { path: '/mantenimientos/planificacion/recetas', label: 'Recetas', icon: <FaUtensils /> },
          { path: '/mantenimientos/planificacion/tipos-componente-menu', label: 'Tipos Componente Menú', icon: <FaUtensils /> },
          { path: '/mantenimientos/planificacion/menus-ciclicos', label: 'Menús Cíclicos', icon: <FaCalendarAlt /> },
        ]
      },
      {
        id: 'negocio',
        label: 'Negocio',
        icon: <FaBuilding />,
        items: [
          { path: '/mantenimiento-clientes', label: 'Clientes', icon: <FaUsers /> },
          { path: '/mantenimiento-proyectos', label: 'Proyectos', icon: <FaProjectDiagram /> },
          { path: '/mantenimiento-proyectos-clientes', label: 'Proyectos - Clientes', icon: <FaProjectDiagram /> },
        ]
      },
      {
        id: 'generales',
        label: 'Generales',
        icon: <FaCog />,
        items: [
          { path: '/mantenimientos/generales/tipo-documentos', label: 'Tipo Documentos', icon: <FaFileAlt /> },
          { path: '/mantenimientos/generales/parametros-generales', label: 'Parámetros generales', icon: <FaCog /> },
          { path: '/mantenimientos/generales/empresa', label: 'Empresa', icon: <FaBuilding /> },
        ]
      },
    ]
  },
  {
    id: 'consultas',
    label: 'Consultas',
    icon: <FaSearch />,
    items: [
      {
        id: 'consultas-generales',
        label: 'Generales',
        icon: <FaClipboardList />,
        items: [
          {
            path: '/consultas/generales/dni-reniec',
            label: 'Consulta DNI RENIEC',
            icon: <FaAddressCard />,
          },
        ],
      },
      {
        id: 'consultas-alimentacion',
        label: 'Alimentación',
        icon: <FaUtensils />,
        items: [
          {
            path: '/consultas/alimentacion/comensales-duplicados',
            label: 'Consulta comensales duplicado',
            icon: <FaUsers />,
          },
          {
            path: '/consultas/alimentacion/servicios-duplicados',
            label: 'Servicios duplicados en comedores',
            icon: <FaUtensils />,
          },
        ],
      },
      {
        id: 'consultas-hoteleria',
        label: 'Hotelería',
        icon: <FaHotel />,
        items: [
          {
            path: '/consultas/hoteleria/historial-huesped',
            label: 'Historial de huésped',
            icon: <FaHistory />,
          },
          {
            path: '/consultas/hoteleria/camas-disponibles',
            label: 'Camas disponibles',
            icon: <FaBed />,
          },
        ],
      },
    ],
  },
  {
    id: 'procesos',
    label: 'Procesos',
    icon: <FaCogs />,
    items: [
      {
        id: 'alimentacion',
        label: 'Alimentación',
        icon: <FaUtensils />,
        items: [
          { path: '/procesos/alimentacion/gestionar-turnos', label: 'Gestionar Turnos', icon: <FaHome /> },
          { path: '/procesos/alimentacion/errores-carga-masiva', label: 'Errores Carga Masiva', icon: <FaExclamationTriangle /> },
          { path: '/procesos/alimentacion/carga-masiva-comensales', label: 'Carga Masiva Comensales', icon: <FaUsers /> },
          { path: '/procesos/alimentacion/carga-masiva-dietas', label: 'Carga Masiva Dietas', icon: <FaUtensils /> },
          { path: '/procesos/alimentacion/carga-masiva-activar-comensales', label: 'Activar/Inactivar Comensales', icon: <FaToggleOn /> },
          { path: '/procesos/alimentacion/carga-externa-atenciones', label: 'Carga Externa de Atenciones', icon: <FaFileExcel /> },
          { path: '/procesos/alimentacion/sistema-offline-contingencia', label: 'Sistema Offline Contingencia', icon: <FaFileAlt /> },
          {
            path: '/procesos/alimentacion/traslado-comensales-comedor',
            label: 'Traslado comensales entre comedores',
            icon: <FaExchangeAlt />,
          },
          {
            path: '/procesos/alimentacion/nivelar-acceso-comensales-comedor',
            label: 'Nivelar acceso entre comedores',
            icon: <FaCopy />,
          },
          {
            path: '/procesos/alimentacion/homologacion-comensales-logiflex',
            label: 'Homologación Comensales Logiflex',
            icon: <FaLink />,
          },
          {
            path: '/procesos/alimentacion/carga-comensales-logiflex',
            label: 'Cargar Comensales Logiflex',
            icon: <FaCloudDownloadAlt />,
          },
          {
            path: '/procesos/alimentacion/traslado-turnos-detalle',
            label: 'Traslado atenciones entre turnos',
            icon: <FaExchangeAlt />,
          },
        ]
      },
      {
        id: 'hoteleria',
        label: 'Hotelería',
        icon: <FaHotel />,
        items: [
          { path: '/procesos/hoteleria/checkin-checkout', label: 'Check-in / Check-out', icon: <FaUserFriends /> },
          { path: '/procesos/hoteleria/checkout-manual', label: 'Check-out manual', icon: <FaSignOutAlt /> },
          { path: '/procesos/hoteleria/carga-masiva-trabajadores', label: 'Carga Masiva Trabajadores', icon: <FaUserTie /> },
          { path: '/procesos/hoteleria/reserva-automatica-camas', label: 'Reserva Automática de Camas', icon: <FaBed /> },
          { path: '/procesos/hoteleria/reserva-manual-camas', label: 'Reserva Manual de Camas', icon: <FaBed /> },
          { path: '/procesos/hoteleria/carga-masiva-camas', label: 'Carga Masiva Camas', icon: <FaBed /> },
          { path: '/procesos/hoteleria/homologacion-camas-logiflex', label: 'Homologación Camas Logiflex', icon: <FaBed /> },
          { path: '/procesos/hoteleria/inventario-alojamiento-logiflex', label: 'Inventario Alojamiento Logiflex', icon: <FaBed /> },
          { path: '/procesos/hoteleria/estado-campamento', label: 'Estado del Campamento', icon: <FaChartBar /> },
          { path: '/procesos/hoteleria/estado-camas-proyecto', label: 'Estado de camas (proyecto)', icon: <FaBed /> },
          { path: '/procesos/hoteleria/housekeeping-diario', label: 'Housekeeping Diario', icon: <FaBed /> },
          { path: '/procesos/hoteleria/cambio-habitacion', label: 'Cambio de Habitación', icon: <FaExchangeAlt /> },
        ]
      },
      {
        id: 'planificacion-insumos',
        label: 'Planificación de Insumos',
        icon: <FaCalendarAlt />,
        items: [
          { path: '/procesos/planificacion-insumos/programacion-menu-ciclico', label: 'Programación Menú Cíclico', icon: <FaCalendarAlt /> },
        ]
      }
    ]
  },
  {
    id: 'reportes',
    label: 'Reportes',
    icon: <FaChartLine />,
    items: [
      { path: '/reportes', label: 'Índice de Reportes', icon: <FaChartBar /> },
      {
        id: 'reportes-alimentacion',
        label: 'Alimentación',
        icon: <FaUtensils />,
        items: [
          {
            path: '/reportes/alimentacion/consolidado-consumos-comensal',
            label: 'Consolidado por Comensal (Campamento)',
            icon: <FaChartBar />,
          },
          {
            path: '/reportes/alimentacion/atencion-por-comedor',
            label: 'Atención por Comedor',
            icon: <FaChartBar />,
          },
          {
            path: '/reportes/alimentacion/comensales-por-comedor',
            label: 'Comensales por Comedor',
            icon: <FaUsers />,
          },
          {
            path: '/reportes/alimentacion/consulta-atenciones-comensales',
            label: 'Consulta de Atenciones por Comensal',
            icon: <FaFileAlt />,
          },
          {
            path: '/reportes/alimentacion/comensales-dietas',
            label: 'Comensales con Dietas',
            icon: <FaUtensils />,
          },
          {
            path: '/reportes/alimentacion/servicios-duplicados-comensales',
            label: 'Servicios duplicados comensales',
            icon: <FaExclamationTriangle />,
          },
        ],
      },
      {
        id: 'planificacion-insumos',
        label: 'Planificación de Insumos',
        icon: <FaCalendarAlt />,
        items: [
          { path: '/reportes/planificacion-insumos/insumos', label: 'Reporte de Insumos', icon: <FaBox /> },
          { path: '/reportes/planificacion-insumos/recetas', label: 'Reporte de Recetas', icon: <FaUtensils /> },
          { path: '/reporte-menus-ciclicos', label: 'Reporte de Menús Cíclicos', icon: <FaUtensils /> },
          { path: '/reportes/planificacion-insumos/programacion-menu-ciclico', label: 'Reporte de Programación Menú Cíclico', icon: <FaCalendarAlt /> },
        ]
      },
      {
        id: 'hoteleria',
        label: 'Hotelería',
        icon: <FaHotel />,
        items: [
          { path: '/reportes/hoteleria/trabajadores', label: 'Reporte de Trabajadores', icon: <FaUserTie /> },
          { path: '/reportes/hoteleria/reporte-ocupabilidad', label: 'Reporte de Ocupabilidad', icon: <FaHistory /> },
          { path: '/reportes/hoteleria/camas', label: 'Reporte de Camas', icon: <FaBed /> },
          { path: '/reportes/hoteleria/reservas', label: 'Reporte de Reservas', icon: <FaCalendarAlt /> },
          { path: '/reportes/hoteleria/habitabilidad', label: 'Reporte de Habitabilidad', icon: <FaChartBar /> },
          { path: '/reportes/hoteleria/valorizacion', label: 'Valorización Hotelería', icon: <FaMoneyBillWave /> },
          { path: '/reportes/hoteleria/historial-huesped', label: 'Historial de huéspedes', icon: <FaHistory /> },
        ]
      },
      {
        id: 'reportes-corporativo',
        label: 'Corporativo',
        icon: <FaBuilding />,
        items: [
          {
            path: '/reportes/corporativo/depositos',
            label: 'Depósitos',
            icon: <FaMoneyBillWave />,
          },
        ]
      },
    ]
  },
  {
    id: 'corporativo',
    label: 'Corporativo',
    icon: <FaBuilding />,
    items: [
      { path: '/resumen-corporativo', label: 'Resumen Corporativo', icon: <FaChartBar /> },
      { path: '/corporativo/depositos', label: 'Depósitos', icon: <FaMoneyBillWave /> },
      { path: '/corporativo/eliminar-depositos', label: 'Eliminar depósitos', icon: <FaTrashAlt /> },
      { path: '/corporativo/centros-costo', label: 'Centros de costo', icon: <FaLayerGroup /> },
      { path: '/corporativo/tipos-deposito', label: 'Tipos de depósito', icon: <FaTags /> },
      { path: '/corporativo/clientes-facturacion', label: 'Clientes (facturación)', icon: <FaUsers /> },
      { path: '/corporativo/facturas-venta', label: 'Facturas de venta', icon: <FaFileInvoice /> },
      { path: '/corporativo/proveedores', label: 'Proveedores', icon: <FaTruck /> },
    ]
  },
  {
    id: 'recursos-humanos',
    label: 'Recursos Humanos',
    icon: <FaUserFriends />,
    items: [
      { path: '/rrhh/empleados', label: 'Empleados', icon: <FaUsers /> },
      { path: '/rrhh/remuneraciones', label: 'Remuneración de Empleados', icon: <FaCoins /> },
      { path: '/rrhh/regimenes-laborales', label: 'Régimenes Laborales', icon: <FaClipboardList /> },
      { path: '/rrhh/parametria', label: 'Parametría', icon: <FaCogs /> },
      { path: '/rrhh/ruster', label: 'RUSTER', icon: <FaCalendarAlt /> },
      { path: '/rrhh/homologacion-boletas', label: 'Homologación Boletas', icon: <FaCogs /> },
      { path: '/rrhh/carga-boletas-planilla', label: 'Carga Planilla Boletas', icon: <FaFileExcel /> },
      { path: '/rrhh/generacion-boletas', label: 'Generación de Boletas', icon: <FaFilePdf /> },
    ]
  },
  {
    id: 'seguridad',
    label: 'Seguridad',
    icon: <FaUserShield />,
    items: [
      { path: '/mantenimiento-usuarios', label: 'Gestión de Usuarios', icon: <FaUserCog /> },
      { path: '/mantenimiento-usuarios-proyectos', label: 'Usuarios - Proyectos', icon: <FaUserTie /> },
      { path: '/corporativo/seguridad/usuarios', label: 'Gestión de Usuarios (Corporativo)', icon: <FaUserCog /> },
      { path: '/corporativo/seguridad/roles', label: 'Gestión de Roles', icon: <FaUserTie /> },
      { path: '/corporativo/seguridad/permisos-roles', label: 'Permisos a Roles', icon: <FaUserShield /> },
      { path: '/corporativo/seguridad/menus-roles', label: 'Opciones de Menú a Roles', icon: <FaList /> },
      { path: '/corporativo/seguridad/usuarios-roles', label: 'Asignar Roles a Usuarios', icon: <FaProjectDiagram /> },
    ]
  }
];

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [expandedSubCategory, setExpandedSubCategory] = useState(null);
  const [sidebarMinimized, setSidebarMinimized] = useState(false);
  const [menuCategories, setMenuCategories] = useState([]);

  // Obtener user y selectedProject de forma estable
  const [userId, setUserId] = useState(() => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || 'null');
      return user?.id || null;
    } catch {
      return null;
    }
  });

  const user = React.useMemo(() => {
    try {
      void userId;
      return JSON.parse(localStorage.getItem('user') || 'null');
    } catch {
      return null;
    }
  }, [userId]);

  const selectedProject = React.useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem('selectedProject') || 'null');
    } catch {
      return null;
    }
  }, []);

  // Sincronizar userId cuando cambie en localStorage
  useEffect(() => {
    const checkUserChange = () => {
      try {
        const currentUser = JSON.parse(localStorage.getItem('user') || 'null');
        const currentUserId = currentUser?.id || null;
        setUserId(prevUserId => {
          // Solo actualizar si realmente cambió
          if (currentUserId !== prevUserId) {
            return currentUserId;
          }
          return prevUserId;
        });
      } catch {
        setUserId(prevUserId => prevUserId !== null ? null : prevUserId);
      }
    };

    // Verificar al montar
    checkUserChange();

    // Escuchar cambios en localStorage (solo entre ventanas)
    const handleStorageChange = (e) => {
      if (e.key === 'user') {
        checkUserChange();
      }
    };
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []); // Solo ejecutar una vez al montar


  // Cargar menú del usuario desde el backend
  useEffect(() => {
    const loadUserMenu = async () => {
      const project = (() => {
        try {
          return JSON.parse(localStorage.getItem('selectedProject') || 'null');
        } catch {
          return null;
        }
      })();

      const applyProjectFilter = (menu) =>
        isCorporativoProject(project) ? filterMenuForCorporativo(menu) : menu;

      if (!userId) {
        console.log('⚠️ [Layout] No hay userId, usando menú por defecto');
        setMenuCategories(applyProjectFilter(DEFAULT_MENU_CATEGORIES));
        return;
      }

      try {
        console.log(`🔍 [Layout] Cargando menú para usuario_id: ${userId}`);
        const response = await menusApi.getMenuUsuario(userId);
        
        console.log('📥 [Layout] Respuesta del backend:', response);
        
        if (response && response.data && Array.isArray(response.data)) {
          console.log(`✅ [Layout] Menú recibido: ${response.data.length} categorías`);
          console.log('📋 [Layout] Menú raw del backend:', JSON.stringify(response.data, null, 2));
          const convertedMenu = convertMenuStructure(response.data);
          const menuForProject = applyProjectFilter(convertedMenu);
          console.log('🔄 [Layout] Menú convertido:', menuForProject);
          setMenuCategories(menuForProject);
        } else {
          console.warn('⚠️ [Layout] No hay datos de menú, usando menú por defecto');
          setMenuCategories(applyProjectFilter(DEFAULT_MENU_CATEGORIES));
        }
      } catch (error) {
        console.error('❌ [Layout] Error al cargar menú del usuario:', error);
        console.error('   Detalles:', error.response?.data || error.message);
        setMenuCategories(applyProjectFilter(DEFAULT_MENU_CATEGORIES));
      }
    };

    loadUserMenu();
  }, [userId]); // Solo depender del userId

  // Auto-expand menu containing current active route
  useEffect(() => {
    const findActiveCategory = (categories) => {
      for (const category of categories) {
        // Para enlaces directos, verificar si la ruta coincide
        if (category.isDirectLink) {
          if (category.path === location.pathname) {
            return category;
          }
        }
        // Para categorías con items, verificar dentro de los items
        else if (category.items) {
          // Verificar si algún item directo coincide
          const directMatch = category.items.find(item => item.path === location.pathname);
          if (directMatch) {
            return category;
          }

          // Verificar si algún subitem coincide (para submenús anidados)
          const subMatch = category.items.find(subcategory =>
            subcategory.items?.some(item => item.path === location.pathname)
          );
          if (subMatch) {
            return category;
          }
        }
      }
      return null;
    };

    const currentCategory = findActiveCategory(menuCategories);
    if (currentCategory && !sidebarMinimized && !currentCategory.isDirectLink) {
      setExpandedCategory(currentCategory.id);

      // También expandir la subcategoría activa
      const activeSubCategory = currentCategory.items?.find(subcategory =>
        subcategory.items?.some(item => item.path === location.pathname)
      );
      if (activeSubCategory) {
        setExpandedSubCategory(activeSubCategory.id);
      }
    }
  }, [location.pathname, sidebarMinimized, menuCategories]);

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const toggleCategory = (categoryId) => {
    setExpandedCategory(expandedCategory === categoryId ? null : categoryId);
  };

  const toggleSubCategory = (subCategoryId) => {
    setExpandedSubCategory(expandedSubCategory === subCategoryId ? null : subCategoryId);
  };

  const toggleSidebar = () => {
    setSidebarMinimized(!sidebarMinimized);
    // Cerrar categorías expandidas cuando se minimiza
    if (!sidebarMinimized) {
      setExpandedCategory(null);
    }
  };

  return (
    <>
      {/* Digital Harmony Sidebar Styles */}
      <style>
        {`
          .dh-sidebar {
            background: linear-gradient(180deg, #1f2937 0%, #111827 100%);
            box-shadow: 4px 0 15px rgba(0, 0, 0, 0.1);
            border-right: 1px solid rgba(255, 255, 255, 0.05);
          }
          
          .dh-sidebar-header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          }
          
          .dh-menu-category {
            border-radius: 10px;
            margin-bottom: 8px;
            transition: all 0.3s ease;
            overflow: hidden;
          }
          
          .dh-menu-category:hover {
            background: rgba(255, 255, 255, 0.05);
            transform: translateX(2px);
          }
          
          .dh-menu-category-button {
            color: #d1d5db !important;
            text-decoration: none !important;
            border: none;
            background: transparent;
            padding: 12px 16px;
            border-radius: 10px;
            transition: all 0.3s ease;
            font-weight: 500;
          }
          
          .dh-menu-category-button:hover {
            color: white !important;
            background: rgba(255, 255, 255, 0.08);
          }
          
          .dh-menu-category-button:focus {
            box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.3);
          }
          
          .dh-menu-category.active .dh-menu-category-button {
            background: linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%);
            color: #667eea !important;
            border-left: 3px solid #667eea;
          }
          
          .dh-menu-item {
            color: #9ca3af;
            text-decoration: none;
            padding: 10px 16px;
            margin: 4px 0;
            border-radius: 8px;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            font-size: 0.9rem;
            position: relative;
          }
          
          .dh-menu-item:hover {
            color: #e5e7eb !important;
            background: rgba(255, 255, 255, 0.05);
            transform: translateX(4px);
            text-decoration: none;
          }
          
          .dh-menu-item.active {
            background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
            color: white !important;
            font-weight: 600;
            box-shadow: 0 4px 12px rgba(17, 153, 142, 0.3);
            border-left: 3px solid #38ef7d;
          }
          
          .dh-menu-item.active:hover {
            color: white !important;
            transform: translateX(2px);
            box-shadow: 0 6px 16px rgba(17, 153, 142, 0.4);
          }
          
          .dh-menu-expand-icon {
            transition: transform 0.3s ease;
          }
          
          .dh-menu-expand-icon.expanded {
            transform: rotate(180deg);
          }
          
          .dh-submenu {
            max-height: 0;
            opacity: 0;
            overflow: hidden;
            transition: all 0.3s ease;
            margin-left: 20px;
            padding-left: 16px;
            border-left: 2px solid rgba(255, 255, 255, 0.1);
          }
          
          .dh-submenu.expanded {
            max-height: 500px;
            opacity: 1;
            padding: 8px 0 8px 16px;
          }
          
          .dh-toggle-btn {
            background: rgba(255, 255, 255, 0.1);
            border: none;
            color: white;
            padding: 8px 12px;
            border-radius: 8px;
            transition: all 0.3s ease;
          }
          
          .dh-toggle-btn:hover {
            background: rgba(255, 255, 255, 0.2);
            color: white;
            transform: scale(1.05);
          }
          
          .dh-user-info {
            background: rgba(255, 255, 255, 0.05);
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 12px;
            padding: 12px;
            margin-bottom: 16px;
          }
          
          .dh-logout-btn {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            border: none;
            color: white;
            padding: 10px 16px;
            border-radius: 10px;
            font-weight: 600;
            transition: all 0.3s ease;
            box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
          }
          
          .dh-logout-btn:hover {
            background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4);
            color: white;
          }
          
          .dh-minimized-icon {
            padding: 8px;
            border-radius: 8px;
            margin-bottom: 8px;
            transition: all 0.3s ease;
            cursor: pointer;
            color: #9ca3af;
          }
          
          .dh-minimized-icon:hover {
            background: rgba(255, 255, 255, 0.1);
            color: white;
            transform: scale(1.1);
          }
          
          .dh-minimized-icon.active {
            background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
            color: white;
            box-shadow: 0 4px 12px rgba(17, 153, 142, 0.3);
          }
          
          .dh-submenu-header {
            transition: all 0.3s ease;
          }
          
          .dh-submenu-header:hover {
            background: rgba(255, 255, 255, 0.08) !important;
            transform: translateX(2px);
          }
          
          .dh-submenu-items {
            transition: all 0.3s ease;
          }
          
          .dh-submenu-items::-webkit-scrollbar {
            width: 6px;
          }
          
          .dh-submenu-items::-webkit-scrollbar-track {
            background: rgba(255, 255, 255, 0.05);
            border-radius: 10px;
          }
          
          .dh-submenu-items::-webkit-scrollbar-thumb {
            background: rgba(102, 126, 234, 0.5);
            border-radius: 10px;
          }
          
          .dh-submenu-items::-webkit-scrollbar-thumb:hover {
            background: rgba(102, 126, 234, 0.7);
          }
          
          .dh-submenu-items .dh-menu-item {
            transition: all 0.3s ease;
          }
          
          .dh-submenu-items .dh-menu-item:hover {
            background: rgba(255, 255, 255, 0.05) !important;
            transform: translateX(4px);
          }
        `}
      </style>

      <div className="d-flex min-vh-100">
        {/* Sidebar */}
        <div
          className="dh-sidebar text-light"
          style={{
            width: sidebarMinimized ? '70px' : '280px',
            minHeight: '100vh',
            position: 'fixed',
            left: 0,
            top: 0,
            transition: 'width 0.3s ease',
            overflowX: 'hidden',
            zIndex: 1000
          }}
        >
          <div className="dh-sidebar-header p-3 d-flex align-items-center justify-content-between">
            {!sidebarMinimized && (
              <h4 className="mb-0 d-flex align-items-center" style={{ fontWeight: 700 }}>
                <FaHome className="me-2" />
                SGC
              </h4>
            )}
            <Button
              className="dh-toggle-btn"
              onClick={toggleSidebar}
              style={{ minWidth: 'auto' }}
            >
              {sidebarMinimized ? <FaBars size={18} /> : <FaChevronLeft size={18} />}
            </Button>
          </div>

          <div className="d-flex flex-column h-100">
            <Nav className="flex-column p-3">
              {sidebarMinimized ? (
                // Vista minimizada - solo iconos
                <>
                  {menuCategories.map((category) => {
                    // Para enlaces directos
                    if (category.isDirectLink) {
                      return (
                        <div
                          key={category.id}
                          className={`dh-minimized-icon text-center ${location.pathname === category.path ? 'active' : ''}`}
                          title={category.label}
                          onClick={() => navigate(category.path)}
                        >
                          {category.icon}
                        </div>
                      );
                    }

                    // Para categorías con submenús
                    const hasActiveItem = category.items?.some(item => item.path === location.pathname);
                    return (
                      <div
                        key={category.id}
                        className={`dh-minimized-icon text-center ${hasActiveItem ? 'active' : ''}`}
                        title={category.label}
                        onClick={() => {
                          setSidebarMinimized(false);
                          setExpandedCategory(category.id);
                        }}
                      >
                        {category.icon}
                      </div>
                    );
                  })}
                </>
              ) : (
                // Vista expandida - iconos y texto
                <>
                  {menuCategories.map((category) => {
                    // Si es un enlace directo, renderizar como enlace simple
                    if (category.isDirectLink) {
                      return (
                        <div key={category.id} className={`dh-menu-category ${location.pathname === category.path ? 'active' : ''}`}>
                          <Nav.Link
                            className="dh-menu-category-button w-100 text-start d-flex align-items-center"
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(category.path);
                            }}
                            style={{ textDecoration: 'none', cursor: 'pointer' }}
                          >
                            <div className="d-flex align-items-center">
                              {category.icon}
                              <span className="ms-3">{category.label}</span>
                            </div>
                          </Nav.Link>
                        </div>
                      );
                    }

                    // Si tiene items, renderizar como menú desplegable
                    const hasActiveItem = category.items?.some(item => {
                      // Verificar items directos
                      if (item.path === location.pathname) return true;
                      // Verificar subitems
                      return item.items?.some(subitem => subitem.path === location.pathname);
                    });
                    const isExpanded = expandedCategory === category.id;

                    return (
                      <div key={category.id} className={`dh-menu-category ${hasActiveItem ? 'active' : ''}`}>
                        <Button
                          className="dh-menu-category-button w-100 text-start d-flex align-items-center justify-content-between"
                          onClick={() => toggleCategory(category.id)}
                        >
                          <div className="d-flex align-items-center">
                            {category.icon}
                            <span className="ms-3">{category.label}</span>
                          </div>
                          <div className={`dh-menu-expand-icon ${isExpanded ? 'expanded' : ''}`}>
                            <FaChevronDown size={12} />
                          </div>
                        </Button>
                        <div className={`dh-submenu ${isExpanded ? 'expanded' : ''}`}>
                          {category.items?.map((item) => {
                            // Si el item tiene subitems (es una subcategoría)
                            if (item.items) {
                              const hasActiveSubItem = item.items.some(subitem => subitem.path === location.pathname);
                              const isSubCategoryExpanded = expandedSubCategory === item.id;

                              return (
                                <div key={item.id} className="mb-2">
                                  <div
                                    className="dh-submenu-header d-flex align-items-center justify-content-between"
                                    onClick={() => toggleSubCategory(item.id)}
                                    style={{
                                      cursor: 'pointer',
                                      padding: '8px 12px',
                                      borderRadius: '6px',
                                      backgroundColor: hasActiveSubItem ? 'rgba(102, 126, 234, 0.1)' : 'rgba(255, 255, 255, 0.05)',
                                      borderLeft: hasActiveSubItem ? '3px solid #667eea' : '3px solid transparent',
                                      transition: 'all 0.3s ease'
                                    }}
                                  >
                                    <div className="d-flex align-items-center">
                                      {item.icon}
                                      <span className="ms-3" style={{ fontWeight: '600', color: hasActiveSubItem ? '#667eea' : '#e5e7eb' }}>
                                        {item.label}
                                      </span>
                                    </div>
                                    <FaChevronDown
                                      size={12}
                                      style={{
                                        transform: isSubCategoryExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.3s ease',
                                        color: hasActiveSubItem ? '#667eea' : '#9ca3af'
                                      }}
                                    />
                                  </div>
                                  <div
                                    className="dh-submenu-items"
                                    style={{
                                      maxHeight: isSubCategoryExpanded ? '180px' : '0',
                                      opacity: isSubCategoryExpanded ? '1' : '0',
                                      overflowY: isSubCategoryExpanded ? 'auto' : 'hidden',
                                      overflowX: 'hidden',
                                      transition: 'all 0.3s ease',
                                      marginLeft: '20px',
                                      paddingLeft: '12px',
                                      paddingRight: '8px',
                                      borderLeft: '2px solid rgba(102, 126, 234, 0.2)'
                                    }}
                                  >
                                    {item.items.map((subitem) => (
                                      <Nav.Link
                                        key={subitem.path}
                                        className={`dh-menu-item ${location.pathname === subitem.path ? 'active' : ''
                                          }`}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          navigate(subitem.path);
                                        }}
                                        style={{
                                          cursor: 'pointer',
                                          fontSize: '0.85rem',
                                          padding: '6px 12px',
                                          margin: '2px 0',
                                          borderRadius: '4px',
                                          backgroundColor: location.pathname === subitem.path ? 'rgba(17, 153, 142, 0.1)' : 'transparent'
                                        }}
                                      >
                                        {subitem.icon}
                                        <span className="ms-3">{subitem.label}</span>
                                      </Nav.Link>
                                    ))}
                                  </div>
                                </div>
                              );
                            }

                            // Si es un item directo
                            return (
                              <Nav.Link
                                key={item.path}
                                className={`dh-menu-item ${location.pathname === item.path ? 'active' : ''
                                  }`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  navigate(item.path);
                                }}
                                style={{ cursor: 'pointer' }}
                              >
                                {item.icon}
                                <span className="ms-3">{item.label}</span>
                              </Nav.Link>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </>
              )}
            </Nav>

            <div className="mt-auto p-3">
              {sidebarMinimized ? (
                // Vista minimizada - solo iconos
                <div className="d-flex flex-column align-items-center">
                  {user && (
                    <div className="dh-minimized-icon" title={user.nombre}>
                      <FaUser size={18} />
                    </div>
                  )}
                  {selectedProject && (
                    <div className="dh-minimized-icon" title={selectedProject.nombre}>
                      <FaBuilding size={18} />
                    </div>
                  )}
                  <Button
                    className="dh-logout-btn p-2 mt-2"
                    onClick={handleLogout}
                    title="Cerrar Sesión"
                    style={{ minWidth: 'auto', fontSize: '0.8rem' }}
                  >
                    <FaSignOutAlt size={14} />
                  </Button>
                </div>
              ) : (
                // Vista expandida - iconos y texto
                <>
                  {user && selectedProject && (
                    <div className="dh-user-info">
                      <div className="d-flex align-items-center mb-2">
                        <FaUser className="me-2" style={{ color: '#667eea' }} />
                        <small style={{ color: '#e5e7eb', fontWeight: 500 }}>{user.nombre}</small>
                      </div>
                      <div className="d-flex align-items-center">
                        <FaBuilding className="me-2" style={{ color: '#11998e' }} />
                        <small style={{ color: '#e5e7eb', fontWeight: 500 }}>{selectedProject.nombre}</small>
                      </div>
                    </div>
                  )}
                  <Button
                    className="dh-logout-btn d-flex align-items-center w-100"
                    onClick={handleLogout}
                  >
                    <FaSignOutAlt className="me-2" />
                    Cerrar Sesión
                  </Button>
                </>
              )}
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div
          className="flex-grow-1 d-flex flex-column"
          style={{
            marginLeft: sidebarMinimized ? '70px' : '280px',
            transition: 'margin-left 0.3s ease'
          }}
        >
          <Container fluid className="flex-grow-1 py-0">
            {children}
          </Container>

          <footer className="dh-sidebar text-light py-3">
            <Container className="text-center">
              <small>© 2024 Sistema de Gestión de Comedores - Digital Harmony</small>
            </Container>
          </footer>
        </div>
      </div>
    </>
  );
};

export default Layout; 
